import { render, staticRenderFns } from "./IconFooterConiverse.vue?vue&type=template&id=4f7110c4"
import script from "./IconFooterConiverse.vue?vue&type=script&lang=js"
export * from "./IconFooterConiverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports